module.exports = __webpack_public_path__ + "img/notification-icon-active.2efcaca5.svg";